import React, 
       { Component } from 'react';
import { connect }   from 'react-redux';
import { Link }      from 'react-router-dom'

class menu_topo extends Component {
    render() {
        return (<div className="topo-pag">
                    <ul className="titulo">
                        {this.props.listaMenuScopo.map((elem,i)=>{ return (elem.action?<li key={i}><Link to={elem.link}>{elem.nome}</Link></li>:<li key={i}>{elem.nome}</li>)})}
                    </ul>
                </div>
        );
    }
}

function mapStateToProps(state){
  
    return {
             menu           : state.configReducer.menu,
             listaMenuScopo : state.scopoReducer.allListaMenu,
           };
}

export default connect(mapStateToProps)(menu_topo);



// WEBPACK FOOTER //
// ./src/components/professor/menu/menu_topo.js